<template>
  <div>
    <loading v-if="Loading" />
    <b-modal v-model="modalShow" title="User" hide-footer>
      <loading v-if="Loading" />
      <validation-observer
        ref="absensi"
        tag="form"
        @submit.prevent="submitAdd"
        v-if="!Loading"
      >
        <b-form @submit.prevent="submitAdd">
          <b-row v-if="!isEdit">
            <b-col cols="12">
              <b-form-group label="Pilih Polisi">
                <validation-provider
                  #default="{ errors }"
                  name="polisi"
                  rules="required"
                >
                  <multiselect
                    v-model="formUser.identifier"
                    :options="dataWarga"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="true"
                    placeholder="Polisi"
                    label="text"
                    track-by="value"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="!isEdit">
            <b-col cols="12">
              <b-form-group label="Pilih Role">
                <validation-provider
                  #default="{ errors }"
                  name="Role"
                  rules="required"
                >
                  <multiselect
                    v-model="formUser.role"
                    :options="dataRole"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="true"
                    placeholder="Role"
                    label="text"
                    track-by="value"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" v-if="!isEdit">
              <b-form-group label="Username">
                <validation-provider
                  #default="{ errors }"
                  name="username"
                  rules="required"
                >
                  <b-form-input
                    v-model="formUser.username"
                    name="username"
                    placeholder="Username"
                    locale="id"
                    now-button
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group label="Password">
                <validation-provider
                  #default="{ errors }"
                  name="password"
                  rules="required"
                >
                  <b-form-input
                    v-model="formUser.password"
                    name="password"
                    placeholder="Password"
                    locale="id"
                    now-button
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button type="submit" variant="primary">Submit</b-button>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal v-model="modalShowRole" title="Ganti Role" hide-footer>
      <loading v-if="Loading" />
      <validation-observer
        ref="role"
        tag="form"
        @submit.prevent="submitEditRole"
        v-if="!Loading"
      >
        <b-form @submit.prevent="submitEditRole">
          <b-row>
            <b-col cols="12">
              <b-form-group label="Pilih Role">
                <validation-provider
                  #default="{ errors }"
                  name="Role"
                  rules="required"
                >
                  <multiselect
                    v-model="formUser.role"
                    :options="dataRole"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="true"
                    placeholder="Role"
                    label="text"
                    track-by="value"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button type="submit" variant="primary">Submit</b-button>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal v-model="modalShowEmail" title="Email" hide-footer>
      <loading v-if="Loading" />
      <validation-observer
        ref="email"
        tag="form"
        @submit.prevent="submitEditEmail"
        v-if="!Loading"
      >
        <b-form @submit.prevent="submitEditEmail">
          <b-row>
            <b-col cols="12">
              <b-form-group label="Email">
                <validation-provider
                  #default="{ errors }"
                  name="email"
                  rules="required|email"
                >
                  <b-form-input
                    v-model="formUser.email"
                    name="email"
                    placeholder="Masukan Email Baru"
                    locale="id"
                    now-button
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-button type="submit" variant="primary">Submit</b-button>
        </b-form>
      </validation-observer>
    </b-modal>

    <!-- Tabel -->
    <b-row>
      <b-col class="col-8">
        <b-form-group>
          <b-button
            v-if="!Loading"
            @click="showModal"
            size="sm"
            variant="primary"
            >Tambah User MDT</b-button
          >
          &nbsp;
        </b-form-group>
      </b-col>
      <b-col class="col-4">
        <b-form-group>
          <b-input v-model="filter" placeholder="Filter"></b-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="!Loading">
      <b-col class="col-12">
        <b-table
          striped
          hover
          :items="filteredTableData"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
        >
          <template v-slot:cell(action)="row">
            <b-button @click="chemail(row.item)" variant="secondary" size="sm"
              >Reset Email</b-button
            >&nbsp;
            <b-button @click="chpass(row.item)" variant="primary" size="sm"
              >Edit Password</b-button
            >&nbsp;
            <b-button @click="chrole(row.item)" variant="warning" size="sm"
              >Ganti Role</b-button
            >&nbsp;
            <b-button @click="deleteUser(row.item)" variant="danger" size="sm"
              >Hapus</b-button
            >&nbsp;
          </template>
        </b-table>
        <br />
        <div class="d-flex justify-content-end">
          <b-pagination
            v-model="currentPage"
            :total-rows="filteredTableData.length"
            :per-page="perPage"
          ></b-pagination>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.full";
import axios from "axios";
import Loading from "@/templates/Loading.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import _interfaces from "@/templates/_interfaces";
import Multiselect from "vue-multiselect";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Loading,
    ToastificationContent,
    Multiselect,
    axios,
  },
  data() {
    return {
      Loading: false,
      perPage: 10, // Jumlah item per halaman
      currentPage: 1, // Halaman saat ini
      fields: [
        { key: "identifier", label: "Steam Hash" },
        { key: "fullname", label: "Nama Lengkap" },
        { key: "username", label: "Username" },
        { key: "email", label: "Email" },
        { key: "role_name", label: "Role" },
        { key: "action", label: "Action" },
      ],
      modalShow: false,
      modalShowRole: false,
      modalShowEmail: false,
      filter: null,
      formUser: _interfaces.master_user,
      tableData: [],
      dataWarga: [],
      dataRole: [],
      isEdit: false,
    };
  },
  computed: {
    filteredTableData() {
      if (this.filter == null) {
        return this.tableData;
      } else {
        return this.tableData.filter((item) => {
          return item.fullname
            .toLowerCase()
            .includes(this.filter.toLowerCase());
        });
      }
    },
  },
  methods: {
    init() {
      this.isEdit = false;
      this.getData();
      this.getDataUser();
      this.getDataRole();
    },
    showModal() {
      this.isEdit = false;
      this.modalShow = true;
    },
    getDataUser() {
      axios
        .get("idp_dropdown/user")
        .then((response) => {
          this.dataWarga = response.data.data;
        })
        .catch((error) => {
          if (error.status === 4000) {
            localStorage.clear();
            this.$router.push({ path: "/login" });
            ({
              title: "Login Expired",
              message: "Sesi Login Habis",
            });
          }
        })
        .finally(() => {
          this.Loading = false;
        });
    },
    getDataRole() {
      axios
        .get("idp_dropdown/role")
        .then((response) => {
          this.dataRole = response.data.data;
        })
        .catch((error) => {
          if (error.status === 4000) {
            localStorage.clear();
            this.$router.push({ path: "/login" });
            ({
              title: "Login Expired",
              message: "Sesi Login Habis",
            });
          }
        })
        .finally(() => {
          this.Loading = false;
        });
    },
    getData() {
      axios
        .post("idp/master/user/list", { id: null })
        .then((response) => {
          this.tableData = response.data.data;
        })
        .catch((error) => {
          if (error.status === 4000) {
            localStorage.clear();
            this.$router.push({ path: "/login" });
            ({
              title: "Login Expired",
              message: "Sesi Login Habis",
            });
          }
        })
        .finally(() => {
          this.Loading = false;
          this.modalShow = false;
        });
    },
    submitAdd() {
      this.$refs.absensi.validate().then((success) => {
        if (success) {
          this.Loading = true;

          setTimeout(() => {
            if (this.isEdit == false) {
              axios
                .post("idp/master/user/add", this.formUser)
                .then((response) => {
                  if (response.data.status == 2000) {
                    this.$swal({
                      title: response.data.message,
                      icon: "success",
                      background: "black",
                      showCancelButton: false,
                      confirmButtonColor: "#7367f0",
                      cancelButtonColor: "#ea5455",
                      confirmButtonText: "ok",
                    });
                  } else {
                    this.$swal({
                      title: response.data.message,
                      icon: "warning",
                      background: "black",
                      showCancelButton: false,
                      confirmButtonColor: "#7367f0",
                      cancelButtonColor: "#ea5455",
                      confirmButtonText: "ok",
                    });
                  }
                })
                .catch((error) => {
                  if (error.status === 4000) {
                    localStorage.clear();
                    this.$router.push({ path: "/login" });
                    ({
                      title: "Login Expired",
                      message: "Sesi Login Habis",
                    });
                  }
                })
                .finally(() => {
                  this.Loading = false;
                  this.modalShow = false;
                  this.init();
                });
            } else {
              axios
                .post("idp/master/user/edit", this.formUser)
                .then((response) => {})
                .catch((error) => {
                  if (error.status === 4000) {
                    localStorage.clear();
                    this.$router.push({ path: "/login" });
                    ({
                      title: "Login Expired",
                      message: "Sesi Login Habis",
                    });
                  }
                })
                .finally(() => {
                  this.Loading = false;
                  this.modalShow = false;
                  this.init();
                });
            }
          }, 1000);
        }
      });
    },
    submitEditRole() {
      this.$refs.role.validate().then((success) => {
        if (success) {
          this.Loading = true;

          setTimeout(() => {
            axios
              .post("idp/master/user/editrole", this.formUser)
              .then((response) => {})
              .catch((error) => {
                if (error.status === 4000) {
                  localStorage.clear();
                  this.$router.push({ path: "/login" });
                  ({
                    title: "Login Expired",
                    message: "Sesi Login Habis",
                  });
                }
              })
              .finally(() => {
                this.Loading = false;
                this.modalShowRole = false;
                this.init();
              });
          }, 1000);
        }
      });
    },
    chpass(row) {
      this.isEdit = true;
      this.formUser.id = row.id;
      this.modalShow = true;
    },
    chemail(row) {
      this.formUser.id = row.id;
      this.formUser.email = row.email;
      this.$swal({
        title: "Hapus Email?",
        icon: "question",
        background: "black",
        showCancelButton: true,
        confirmButtonColor: "#7367f0",
        cancelButtonColor: "#ea5455",
        confirmButtonText: "Save",
      }).then((result) => {
        if (result.isConfirmed) {
          this.Loading = true;
          setTimeout(() => {
            axios
              .post("idp/master/user/reset-email", this.formUser)
              .then((response) => {
                this.$swal({
                  title: "Sukses",
                  icon: "success",
                  background: "black",
                  showCancelButton: false,
                  confirmButtonColor: "#7367f0",
                  cancelButtonColor: "#ea5455",
                  confirmButtonText: "Save",
                });
              })
              .catch((error) => {
                if (error.status === 4000) {
                  localStorage.clear();
                  this.$router.push({ path: "/login" });
                  ({
                    title: "Login Expired",
                    message: "Sesi Login Habis",
                  });
                }
              })
              .finally(() => {
                this.Loading = false;
                this.modalAkses = false;
                this.init();
              });
          }, 1000);
        } else {
          this.modalAkses = false;
        }
      });
    },
    chrole(row) {
      this.isEdit = true;
      this.formUser.id = row.id;
      this.modalShowRole = true;
    },
    deleteUser(row) {
      this.formUser.id = row.id;
      this.$swal({
        title: "Hapus User?",
        icon: "question",
        background: "black",
        showCancelButton: true,
        confirmButtonColor: "#7367f0",
        cancelButtonColor: "#ea5455",
        confirmButtonText: "Save",
      }).then((result) => {
        if (result.isConfirmed) {
          this.Loading = true;
          setTimeout(() => {
            axios
              .post("idp/master/user/delete", this.formUser)
              .then((response) => {
                this.$swal({
                  title: "Sukses",
                  icon: "success",
                  background: "black",
                  showCancelButton: false,
                  confirmButtonColor: "#7367f0",
                  cancelButtonColor: "#ea5455",
                  confirmButtonText: "Save",
                });
              })
              .catch((error) => {
                if (error.status === 4000) {
                  localStorage.clear();
                  this.$router.push({ path: "/login" });
                  ({
                    title: "Login Expired",
                    message: "Sesi Login Habis",
                  });
                }
              })
              .finally(() => {
                this.Loading = false;
                this.modalAkses = false;
                this.init();
              });
          }, 1000);
        } else {
          this.modalAkses = false;
        }
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
